import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../../../../public/icons/workflow/open_subprocess.svg'


const _hoisted_1 = { class: "htmleditor rich-text-editor" }
const _hoisted_2 = { style: {"text-align":"right"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_rich_text_editor = _resolveComponent("f-rich-text-editor")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_f_rich_text_editor, {
      class: "f-rich-text-editor",
      html: _ctx.editorHtmlValue,
      translator: _ctx.translate,
      "has-image": true,
      "onUpdate:html": _ctx.onRichTextEditor
    }, null, 8, ["html", "translator", "onUpdate:html"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ShowPopup && _ctx.ShowPopup(...args)), ["prevent"]))
      }, _hoisted_4)
    ]),
    (_ctx.PopupVisible)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.HidePopup(false)))
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Localizer.Localize('Edit')), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_f_rich_text_editor, {
                class: "f-rich-text-editor",
                "has-image": true,
                html: _ctx.popupValue,
                translator: _ctx.translate,
                "onUpdate:html": _cache[1] || (_cache[1] = newValue => _ctx.popupValue = newValue)
              }, null, 8, ["html", "translator"])
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Default,
              text: _ctx.Localizer.Localize('Cancel_PascalCase'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.HidePopup(false)))
            }, null, 8, ["type", "text"]),
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Primary,
              text: _ctx.Localizer.Localize('Ok_PascalCase'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.HidePopup(true)))
            }, null, 8, ["type", "text"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}